const GENRE_KEY = 'genre';

const getActiveGenre = (filters) => {
  const genres = filters.filter(({ model }) => model === GENRE_KEY);

  return genres?.length === 1 ? genres[0].name : null;
};

export default getActiveGenre;
